<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        // type: Object || String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
            temp_value: null
        };
    },
    watch: {
        item_value: {
            handler(val) {
                if(this.temp_value != val) this.value = val;
            },
            deep: true
        },
        value(val) {
            const temp = []
            if(val.length == 0) {
                temp.push({name: "Closed",value: false})
                temp.push({name: "Interim Closure",value: false})
            } 
            else if(val.length == 1) {
                if(val[0].name == 'Closed') {
                    temp.push(val[0])
                    temp.push({name: "Interim Closure",value: false})
                }
                else if(val[0].name == 'Interim Closure') {
                    temp.push(val[0])
                    temp.push({name: "Closed",value: false})
                }
            }
            else if(val.length == 2) {
                if(val.filter(x => x.name == 'Interim Closure').length == 1) {
                    temp.push(val.filter(x => x.name == 'Closed')[0] ? val.filter(x => x.name == 'Closed')[0] : {name: "Closed",value: false})
                    temp.push(val.filter(x => x.name == 'Interim Closure')[0])
                }
                else if(val.filter(x => x.name == 'Closed').length == 1) {
                    temp.push(val.filter(x => x.name == 'Interim Closure')[0] ? val.filter(x => x.name == 'Interim Closure')[0] : {name: "Interim Closure",value: false})
                    temp.push(val.filter(x => x.name == 'Closed')[0])
                }
                else {
                    temp.push({name: "Closed",value: false})
                    temp.push({name: "Interim Closure",value: true})
                }
            }
            else if(val.length == 3) {
                if(val.filter(x => x.name == 'Closed').length == 2) {
                    temp.push({name: "Closed",value: true})
                    temp.push(val.filter(x => x.name == 'Interim Closure')[0])
                }
                else if(val.filter(x => x.name == 'Interim Closure').length == 2) {
                    temp.push({name: "Interim Closure",value: true})
                    temp.push(val.filter(x => x.name == 'Closed')[0])
                }
                else {
                    temp.push({name: "Closed",value: true})
                    temp.push({name: "Interim Closure",value: true})
                }
            }
            else if(val.length == 4) {
                temp.push({name: "Closed",value: true})
                temp.push({name: "Interim Closure",value: true})
            }
            this.temp_value = temp  
            this.updateValue(this.item_key, temp);
        },
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="row col-12">
            <div v-for="option in item.options" v-bind:key="option.name" class="form-check col-4">
                <input class="form-check-input" type="checkbox" v-model="value" v-bind:value="option">
                <label class="form-check-label">{{option.name}}</label>
            </div>
        </div>

        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



